import { useContext } from "react";
import { UserContext } from "../../context/provider";
import { exportToCSV, FileInput } from "../mostlyUsed/mainComponents";

const CompareCustomer = () => {
  const { fileDatas, setFileDatas, verifiedCodes } = useContext(UserContext);

  const submit = () => {

    const idIndex = 0
    const nameIndex = 2
    const phoneIndex = 15

    for( let i of fileDatas.secondCustomer ){
      console.log(i[idIndex]);
      for(let g in fileDatas.mainCustomer){
        if( (i[idIndex] === fileDatas.mainCustomer[g][idIndex]) || (i[nameIndex] === fileDatas.mainCustomer[g][nameIndex]) ){
          fileDatas.mainCustomer.splice(g, 1);
          break;
        }
      }
    }

    for(let i in fileDatas.mainCustomer){
      for(let g of fileDatas.customerPhone){
        if(fileDatas.mainCustomer[i][idIndex] === g[idIndex]){
          fileDatas.mainCustomer[i].push(g[phoneIndex])
        }
      }
    }
    fileDatas.mainCustomer.unshift(fileDatas.secondCustomer[0])
    console.log(fileDatas.mainCustomer);
    
    console.log("final : ", fileDatas.mainCustomer);
    exportToCSV(fileDatas.mainCustomer, null, "anbar")
  }

  return (
    <div className="mainComponent">
      <FileInput
        title="فایل اکسل اصلی مشتریان"
        fileName="mainCustomer"
        contextData={setFileDatas}
      />
      <FileInput
        title="فایل اکسل مشتریانی که می خواهید از مشتریان اصلی کم شود"
        fileName="secondCustomer"
        contextData={setFileDatas}
      />
      <FileInput
        title="فایل کل مشتریان"
        fileName="customerPhone"
        contextData={setFileDatas}
      />
      <div>
        <button onClick={submit}>تایید</button>
      </div>
    </div>
  );
};

export default CompareCustomer;
